import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Input,
  FormFeedback,
  FormText,
} from "reactstrap";
import * as usuarioController from "../../../controllers/usuarioController";
import {
  notifySuccess,
  notifyError,
} from "../../../components/message/message";

const DeleteUserModal = ({
  isOpen,
  toggle,
  onConfirm,
  itemSelected,
  pageSize,
  search,
  refreshList,
}) => {
  const [observation, setObservation] = useState("");
  const [validationError, setValidationError] = useState("");

  const validateObservation = () => {
    if (!observation.trim()) {
      setValidationError("Campo observação é obrigatório");
      return false;
    }
    if (observation.length > 120) {
      setValidationError("Observação deve ter até 120 caracteres");
      return false;
    }
    setValidationError("");
    return true;
  };

  const handleDelete = async () => {
    if (!validateObservation()) return;

    try {
      const data = await usuarioController.deleteById(
        itemSelected,
        observation,
        0,
        pageSize,
        search
      );

      if (data?.success) {
        notifySuccess("Usuário desativado com sucesso");
        setObservation("");
        toggle();
      }
    } catch (error) {
      console.error("Erro ao desativar usuário:", error);
      notifyError("Erro ao desativar usuário");
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        setObservation("");
        toggle();
      }}
      centered
      size="md"
    >
      <ModalHeader toggle={toggle} className="border-0 pb-1">
        <h5 className="mb-0 fw-bold">Desativar usuário</h5>
      </ModalHeader>

      <ModalBody className="pt-1">
        <div className="mb-3">
          <p className="text-muted mb-4">
            Esta ação irá desativar o acesso do usuário ao sistema.
            <br />
            <strong>Confirme a operação com uma observação:</strong>
          </p>

          <FormGroup className="mb-3">
            <Input
              type="textarea"
              placeholder="Descreva o motivo da desativação*"
              value={observation}
              onChange={(e) => setObservation(e.target.value)}
              invalid={!!validationError}
              className="rounded-2"
              style={{
                minHeight: "100px",
                resize: "vertical",
              }}
              maxLength={120}
            />
            <div className="d-flex justify-content-between mt-2">
              <FormText color="muted">Máximo 120 caracteres</FormText>
              <FormText color={observation.length === 120 ? "danger" : "muted"}>
                {observation.length}/120
              </FormText>
            </div>
            <FormFeedback>{validationError}</FormFeedback>
          </FormGroup>
        </div>

        <div
          className="m-3"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Button
            onClick={() => {
              setObservation("");
              toggle();
            }}
            color="danger"
            style={{ width: "100px", marginRight: "15px" }}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleDelete}
            style={{
              width: "100px",
              marginLeft: "15px",
              background: "var(--color-verde)",
              border: "none",
            }}
          >
            Confirmar
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DeleteUserModal;
